export default __webpack_public_path__ + "static/media/9-Pre-Listing-teamtrainedto.208c688d.png";